import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
    IconArrowBigUpFilled,
    IconBrandLinkedin,
    IconBrandInstagram,
    IconMail,
    IconKeyboard,
    IconPhone,
    IconBrandX
} from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function Footer() {
    const [contactData, setContactData] = useState(null);

    useEffect(() => {
        async function fetchContact() {
            try {
                const response = await axios.get("https://admin.k12pulse.com/api/iletisim");
                if (response?.data?.data?.[0]) {
                    setContactData(response.data.data[0]);
                } else {
                    console.warn("İletişim verisi eksik");
                }
            } catch (error) {
                console.error("İletişim verisi alınamadı:", error);
            }
        }

        fetchContact();
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer>
            <div className='footer-top'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={12} lg={5} className='mb-4 pb-2'>
                            <h3 className='mb-3'>{contactData?.title || "ADRES"}</h3>
                            <small>
                                {contactData?.address?.split("\n").map((line, i) => (
                                    <span key={i}>
                    {line}<br className='d-none d-lg-block' />
                  </span>
                                ))}
                            </small>
                        </Col>
                        <Col lg={5}>
                            <h3 className='mb-3'>BİLGİ</h3>
                            <Row>
                                {contactData?.linkedin && (
                                    <Col xs={6} className='mb-4'>
                                        <Link to={contactData.linkedin} target="_blank" className='d-flex align-items-center'>
                                            <IconBrandLinkedin className='me-3' />LinkedIn
                                        </Link>
                                    </Col>
                                )}
                                {contactData?.instagram && (
                                    <Col xs={6} className='mb-4'>
                                        <Link to={contactData.instagram} target="_blank" className='d-flex align-items-center'>
                                            <IconBrandInstagram className='me-3' />Instagram
                                        </Link>
                                    </Col>
                                )}
                                {contactData?.twitter && (
                                    <Col xs={6} className='mb-4'>
                                        <Link to={contactData.twitter} target="_blank" className='d-flex align-items-center'>
                                            <IconBrandX className='me-3' />X
                                        </Link>
                                    </Col>
                                )}
                                {contactData?.mail && (
                                    <Col xs={6} className='mb-4'>
                                        <Link to={`mailto:${contactData.mail}`} target="_blank" className='d-flex align-items-center'>
                                            <IconMail className='me-3' />E-Mail
                                        </Link>
                                    </Col>
                                )}
                                {contactData?.phone_number && (
                                    <Col xs={6} className='mb-4'>
                                        <Link to={`tel:${contactData.phone_number}`} className='d-flex align-items-center'>
                                            <IconPhone className='me-3' />{contactData.phone_number}
                                        </Link>
                                    </Col>
                                )}
                                <Col xs={6} className='mb-4'>
                                    <Link to="/" className='d-flex align-items-center'>
                                        <IconKeyboard className='me-3' />Blog
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className='footer-bottom'>
                <Container>
                    <Row>
                        <Col md={{ span: 10, offset: 1 }} className='d-flex justify-content-between'>
                            <small>© {new Date().getFullYear()} ⎯ Tüm Hakları Saklıdır.</small>
                            <Link onClick={scrollToTop}><IconArrowBigUpFilled size={24} /></Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    );
}

export default Footer;
